//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import {mapGetters} from "vuex";

export default {
  name: "SectionMunicipalitySliderRoutes",
  components: {
    EmptyEntityCardsSlider: () => import("@/components/common/EmptyEntityCardsSlider"),
    Section: () => import("@/components/common/Section/index"),
    Scroller: () => import("@/components/common/Scroller/index"),
    SliderWithBullets: () => import("@/components/common/SliderWithBullets/index"),
    RouteCard: () => import("@/components/common/RouteCard/index"),
  },
  computed: {
    ...mapGetters({
      cityId: 'municipality/id',
      routes: "routes/routes",
      pending: "routes/pending"
    }),
    show() {
      return this.pending || this?.routes?.length > 0;
    }
  },
  mounted() {
    const payload = {
      clear: true,
      params: {
        city_id: this.cityId,
        resolution: "micro",
        count: 100500,
        lang: this.$i18n.locale
      }
    };
    if (this.cityId) {
      this.$store.dispatch("routes/fetch", payload);
    }
  },
};
